import { TrendingUp, TrendingDown } from "lucide-react";

interface MarketMoverBadgeProps {
  delta: number;
}

/**
 * Small badge showing the magnitude of a market move (e.g. "+8pts" or "-5pts").
 * Green for positive moves, red for negative.
 */
const MarketMoverBadge = ({ delta }: MarketMoverBadgeProps) => {
  const isPositive = delta > 0;
  const Icon = isPositive ? TrendingUp : TrendingDown;
  const sign = isPositive ? "+" : "";
  const pts = Math.round(delta);

  return (
    <span
      className={`inline-flex items-center gap-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
        isPositive
          ? "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400"
          : "bg-red-500/15 text-red-600 dark:text-red-400"
      }`}
      title="Market probability moved significantly since this article was published"
    >
      <Icon className="w-2.5 h-2.5" />
      {sign}{pts}pts
    </span>
  );
};

export default MarketMoverBadge;
